import React from 'react'
import PropTypes from 'prop-types'

// material ui components
import theme from '../theme'

const styles = {
    path: {
        vectorEffect: 'non-scaling-stroke',
        strokeLinejoin: 'miter',
        strokeLinecap: 'square',
        strokeMiterlimit: '3',
    },
}

const rotatingFanSVG = ({ classes, color, width, height }) => (
    <svg version="1.1" viewBox="0 0 47.646 48.001" width={width} height={height}>
        <g>
            <path
                d=" M 24.428 17.255 C 24.554 17.255 24.68 17.255 24.806 17.255 C 24.996 17.318 25.248 17.381 25.438 17.381 C 26.889 17.76 28.151 18.643 28.972 19.906 C 32.884 18.517 36.86 19.527 40.268 21.294 C 41.53 21.988 42.981 20.915 42.729 19.527 C 42.161 16.498 41.025 13.973 39.195 11.512 C 38.564 10.629 37.112 8.988 36.103 8.42 C 34.714 7.663 33.2 7.726 31.874 8.42 C 29.287 9.808 26.889 11.702 25.374 14.289 C 25.059 14.92 24.743 15.551 24.554 16.182 C 24.428 16.498 24.302 16.876 24.239 17.192 C 24.175 17.318 24.365 17.255 24.428 17.255 L 24.428 17.255 Z "
                fill={color}/>
            <path
                d=" M 21.02 22.935 C 21.02 24.702 22.408 26.09 24.112 26.09 C 25.879 26.09 27.268 24.702 27.268 22.935 C 27.268 21.231 25.879 19.842 24.112 19.842 C 22.408 19.842 21.02 21.231 21.02 22.935 Z "
                fill={color}/>
            <path
                d=" M 14.205 20.852 C 15.214 21.609 16.287 22.177 17.423 22.556 C 17.675 22.682 17.928 22.745 18.18 22.808 C 18.243 22.808 18.306 22.808 18.37 22.872 C 18.496 22.872 18.433 22.745 18.433 22.682 C 18.433 22.556 18.433 22.367 18.496 22.24 C 18.559 21.546 18.748 20.915 19.064 20.284 C 19.379 19.716 19.758 19.211 20.263 18.77 C 20.515 18.517 20.768 18.328 21.02 18.139 C 21.146 18.075 20.957 17.886 20.957 17.823 C 20.957 17.697 20.894 17.571 20.831 17.444 C 20.515 16.245 20.389 15.046 20.452 13.847 C 20.578 11.26 21.336 9.051 22.472 6.779 C 23.166 5.517 22.093 4.129 20.705 4.318 C 17.675 4.886 15.151 6.022 12.69 7.852 C 11.87 8.546 10.166 9.998 9.598 10.944 C 8.84 12.27 8.84 13.847 9.598 15.173 C 10.797 17.381 12.185 19.274 14.205 20.852 L 14.205 20.852 Z "
                fill={color}/>
            <path
                d=" M 23.573 27.978 C 23.447 27.978 23.321 27.978 23.195 27.978 C 23.005 27.915 22.753 27.852 22.564 27.852 C 21.112 27.473 19.85 26.59 19.03 25.328 C 15.117 26.716 11.141 25.706 7.733 23.939 C 6.471 23.245 5.02 24.318 5.272 25.706 C 5.84 28.735 6.976 31.26 8.806 33.721 C 9.437 34.604 10.889 36.245 11.898 36.813 C 13.287 37.57 14.801 37.507 16.127 36.813 C 18.714 35.425 21.112 33.532 22.627 30.944 C 22.942 30.313 23.258 29.682 23.447 29.051 C 23.573 28.735 23.699 28.357 23.763 28.041 C 23.826 27.915 23.636 27.978 23.573 27.978 L 23.573 27.978 Z "
                fill={color}/>
            <path
                d=" M 33.977 25.078 C 32.967 24.32 31.894 23.752 30.758 23.374 C 30.506 23.247 30.253 23.184 30.001 23.121 C 29.938 23.121 29.875 23.121 29.812 23.058 C 29.685 23.058 29.749 23.184 29.749 23.247 C 29.749 23.374 29.749 23.563 29.685 23.689 C 29.622 24.383 29.433 25.014 29.117 25.646 C 28.802 26.213 28.423 26.718 27.918 27.16 C 27.666 27.413 27.414 27.602 27.161 27.791 C 27.035 27.854 27.224 28.044 27.224 28.107 C 27.224 28.233 27.287 28.359 27.351 28.485 C 27.666 29.684 27.792 30.883 27.729 32.082 C 27.603 34.67 26.846 36.879 25.71 39.15 C 25.016 40.413 26.088 41.801 27.477 41.612 C 30.506 41.044 33.03 39.908 35.491 38.078 C 36.312 37.383 38.016 35.932 38.584 34.985 C 39.341 33.66 39.341 32.082 38.584 30.757 C 37.384 28.548 35.996 26.655 33.977 25.078 L 33.977 25.078 Z "
                fill={color}/>
        </g>
        <g>
            <path style={styles.path}
                d=" M 23.101 40.359 C 20.314 40.101 20.676 40.145 18.375 39.351 C 16.154 38.586 16.428 37.383 18.306 38.133 C 20.147 38.867 20.154 38.789 22.076 39.351 C 25.238 40.277 24.824 40.519 23.101 40.359 Z "
                fill={color}/>
            <path style={styles.path}
                d=" M 24.722 37.094 C 22.442 36.926 22.739 36.954 20.857 36.436 C 19.04 35.936 19.264 35.15 20.8 35.64 C 22.306 36.12 22.312 36.069 23.884 36.436 C 26.47 37.04 26.131 37.198 24.722 37.094 Z "
                fill={color}/>
        </g>
        <g>
            <path style={styles.path}
                d=" M 5.683 21.15 C 5.782 18.352 5.759 18.717 6.42 16.374 C 7.058 14.113 8.274 14.317 7.633 16.236 C 7.004 18.115 7.083 18.118 6.631 20.069 C 5.888 23.279 5.622 22.879 5.683 21.15 Z "
                fill={color}/>
            <path style={styles.path}
                d=" M 9.036 22.582 C 9.074 20.296 9.063 20.594 9.472 18.685 C 9.868 16.843 10.665 17.021 10.264 18.583 C 9.871 20.114 9.922 20.117 9.645 21.707 C 9.19 24.324 9.013 23.995 9.036 22.582 Z "
                fill={color}/>
            <path style={styles.path}
                d=" M 25.019 5.046 C 27.794 5.416 27.433 5.358 29.7 6.243 C 31.889 7.098 31.567 8.289 29.72 7.464 C 27.911 6.656 27.9 6.734 26.003 6.094 C 22.88 5.042 23.304 4.817 25.019 5.046 Z "
                fill={color}/>
            <path style={styles.path}
                d=" M 23.268 8.243 C 25.539 8.503 25.244 8.463 27.104 9.057 C 28.899 9.629 28.644 10.405 27.128 9.854 C 25.643 9.314 25.635 9.365 24.079 8.935 C 21.519 8.227 21.864 8.082 23.268 8.243 Z "
                fill={color}/>
            <path style={styles.path}
                d=" M 42.327 24.39 C 42.022 27.173 42.071 26.811 41.239 29.098 C 40.436 31.307 39.238 31.013 40.019 29.147 C 40.785 27.319 40.707 27.31 41.302 25.398 C 42.28 22.252 42.515 22.67 42.327 24.39 Z "
                fill={color}/>
            <path style={styles.path}
                d=" M 39.089 22.715 C 38.882 24.991 38.915 24.695 38.366 26.568 C 37.835 28.376 37.054 28.139 37.569 26.611 C 38.074 25.114 38.023 25.107 38.417 23.542 C 39.065 20.966 39.217 21.307 39.089 22.715 Z "
                fill={color}/>
        </g>

    </svg>
)

rotatingFanSVG.defaultProps = {
    color: theme.palette.svgs.rotatingFanSVG,
    width: 24,
    height: 24,
}

rotatingFanSVG.propTypes = {
    classes: PropTypes.objectOf(PropTypes.string).isRequired,
    color: PropTypes.string,
    width: PropTypes.number,
    height: PropTypes.number,
}

export default rotatingFanSVG
